import { RootState } from "@/store/rootReducer";
import { logout } from "@/store/slices/authSlice";
import { store } from "@/store/store";
import { ApiRequestOptions } from "@/types/ApiRequestOptions";
import { ApiResponse } from "../types/ApiResponse";
import { AppConstants } from "@/app.constants";

export async function clivApiRequest<T>({
  method = "GET",
  url,
  params,
  body,
  headers = {},
  signal,
}: ApiRequestOptions, skipAuth = false): Promise<ApiResponse<T>> {
  try {
    const urlObj = new URL(url);
    const token = (store.getState() as RootState).auth.token;

    // Append query parameters for GET requests
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        urlObj.searchParams.append(key, String(value));
      });
    }
    const authToken = `Bearer ${token}`;
    const options: RequestInit = {
      method,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      ...(signal && { signal }),
      credentials: "include",
    };
    if (!skipAuth) {

      options.headers = { ...options.headers, Authorization: authToken };
    }
    // Add body for methods other than GET
    if (body && method !== "GET") {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(urlObj.toString(), options);

    let responseData = null;
    if (response.status === 401) {
      store.dispatch(logout());
    }
    if ((response.ok && response.status !== 204) || response.status === 403) {
      // Parse response only if not empty
      responseData = await response.json();
    }

    return {
      requestId: response.headers.get(AppConstants.REQUEST_ID_HEADER) || '',
      data: responseData,
      status: response.status,
      ok: response.ok,
    };
  } catch (error: any) {
    return {
      requestId: '',
      data: null,
      status: 500,
      ok: false,
      error: error.message || "An unexpected error occurred",
    };
  }
}
